import Repository from './ResearchRepository';

export default {
  async getResearchesByProvince() {
    let url = 'fraser_sr_research_data';

    let researches = await Repository.get(url).catch((e) => {
      console.error(e);
    });

    if (researches.data.length > -1) {
      return researches.data;
    }
    else {
      return {};
    }
  },
}
